import { render } from "./orphanedCourses.vue?vue&type=template&id=685fcc96"
import script from "./orphanedCourses.vue?vue&type=script&lang=js"
export * from "./orphanedCourses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__